export default __webpack_public_path__ + "static/media/ic_chevron_down.0fb015f3.svg";